import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Metric } from "@/components/Metric";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { relativeTime } from "@/lib/format";

export default function Overview() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/customer/dashboard").then((r) => setData(r.data));
  }, []);
  if (!data) return <div className="overline text-stone-500">Loading…</div>;

  return (
    <div className="space-y-8" data-testid="customer-overview">
      <PageHeader
        eyebrow="Customer portal"
        title={`Hello, ${user?.name?.split(" ")[0] || ""}.`}
        description={user?.company?.name ? `Your project portal with ${user.company.name}.` : "Your project portal."}
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Metric label="My units" value={data.units} accent testId="metric-units" />
        <Metric label="Projects" value={data.projects} testId="metric-projects" />
        <Metric label="Unpaid dues" value={data.unpaid} testId="metric-unpaid" />
        <Metric label="Unread alerts" value={data.unread_alerts} testId="metric-unread" />
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <div className="overline text-stone-500">Latest project updates</div>
          <Link to="/portal/updates" className="text-xs font-bold uppercase tracking-wider text-brand-600" data-testid="link-all-updates">
            View all →
          </Link>
        </div>
        <div className="timeline">
          {data.recent_updates?.length ? data.recent_updates.map((u) => (
            <div key={u.id} className="relative pb-6">
              <div className="timeline-dot" />
              <div className="grid-surface p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="overline text-brand-600">{u.project?.name} {u.milestone && `· ${u.milestone}`}</div>
                    <h3 className="font-display text-lg font-bold mt-1">{u.title}</h3>
                  </div>
                  <div className="text-xs text-stone-500 font-mono whitespace-nowrap">{relativeTime(u.created_at)}</div>
                </div>
                <p className="text-sm text-stone-700 mt-2">{u.body}</p>
              </div>
            </div>
          )) : (
            <div className="grid-surface border-dashed p-8 text-center text-stone-400 overline">
              Your builder hasn't posted updates yet
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
